/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Link } from './link';
import { ProcessDetailViewDTO } from './processDetailViewDTO';

export interface EtlProcessDetailViewDTO extends ProcessDetailViewDTO { 
    id?: string;
    name?: string;
    code?: string;
    description?: string;
    scheduleJob?: EtlProcessDetailViewDTO.ScheduleJobEnum;
    schedulers?: string;
    partner?: string;
    typeLoad?: string;
    typeObject?: string;
}
export namespace EtlProcessDetailViewDTO {
    export type ScheduleJobEnum = 'DAILY' | 'MONTHLY' | 'NONE';
    export const ScheduleJobEnum = {
        DAILY: 'DAILY' as ScheduleJobEnum,
        MONTHLY: 'MONTHLY' as ScheduleJobEnum,
        NONE: 'NONE' as ScheduleJobEnum
    };
}